import { message } from 'antd'
import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../modules/userActions'
import { constants as usersConstants } from '../modules/usersActions'
import * as api from '../api/user'

function* getUsers(action) {
  try {
    const payload = yield call(api.getUsers)
    yield put({ type: constants.GET_USERS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_USERS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetUsers() {
  yield takeLatest(constants.GET_USERS.ACTION, getUsers)
}

function* getAllUsers(action) {
  try {
    const payload = yield call(api.getAllUsers)
    yield put({ type: constants.GET_ALL_USERS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_ALL_USERS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAllUsers() {
  yield takeLatest(constants.GET_ALL_USERS.ACTION, getAllUsers)
}

function* getUserRoles(action) {
  try {
    const roles = yield call(api.getUserRoles)
    yield put({ type: constants.GET_USER_ROLES.SUCCESS, roles })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_USER_ROLES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetUserRoles() {
  yield takeLatest(constants.GET_USER_ROLES.ACTION, getUserRoles)
}

function* setInitialPassword(action) {
  try {
    const payload = {
      username: action.username,
      password: action.password
    }
    yield call(api.setInitialPassword, payload)
    yield put({ type: constants.SET_INITIAL_PASSWORD.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SET_INITIAL_PASSWORD.FAILED,
      message: e.message || e
    })
  }
}

function* watchsSetInitialPassword() {
  yield takeLatest(constants.SET_INITIAL_PASSWORD.ACTION, setInitialPassword)
}

function* updateUser(action) {
  try {
    const payload = yield call(api.updateUser, action)
    yield put({ type: constants.USER_UPDATE.SUCCESS, payload })
    yield put({ type: usersConstants.USERS_REFRESH.ACTION })
    message.success('User updated with success!')
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.USERS_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateUser() {
  yield takeLatest(constants.USER_UPDATE.ACTION, updateUser)
}

function* deleteUser(action) {
  try {
    const payload = yield call(api.deleteUser, action)
    yield put({ type: constants.USER_DELETE.SUCCESS, payload })
    yield put({ type: usersConstants.USERS_REFRESH.ACTION })
    message.success('User deleted with success!')
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.USERS_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteUser() {
  yield takeLatest(constants.USER_DELETE.ACTION, deleteUser)
}

function* createUser(action) {
  try {
    const payload = yield call(api.createUser, action)
    yield put({ type: constants.USER_CREATE.SUCCESS, payload })
    yield put({ type: usersConstants.USERS_REFRESH.ACTION })
    message.success('User created with success!')
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    message.error(e.message)
    yield put({
      type: constants.USER_CREATE.FAILED
    })
  }
}

/**
 * Saga
 */
function* watchCreateUser() {
  yield takeLatest(constants.USER_CREATE.ACTION, createUser)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchGetUsers),
    fork(watchsSetInitialPassword),
    fork(watchGetUserRoles),
    fork(watchUpdateUser),
    fork(watchDeleteUser),
    fork(watchCreateUser),
    fork(watchGetAllUsers)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/userSaga.js